const chars = 'ABCDEFGHIJKLMNOPQRSTUVWXYZ';

const charsMap: Record<string, string> = Array.from(chars)
    .reduce((x, char, index) => ({ ...x, [index.toString(chars.length)]: char }), {});

export function getLetterIndex(index: number): string {
    return index.toString(chars.length).replace(/./g, (x) => charsMap[x]);
}
